import { useMemo } from "react";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { ScreenSizes } from "@src/types/screen";
import Routes from "@navigations/Routes";
import { componentMap } from "./convertTabsData";
import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import { useTheme } from "styled-components/native";
import { filterDataByPriceMode } from "@utils/product/productValidators";

const useTabsData = () => {
  const userInfo = useUserInfo();
  const theme = useTheme();
  const { navigationData } = useNavigationMenuSlice();
  const sortedSections = useMemo(() => {
    return [...navigationData.sections]
      .filter((option) => {
        if (option.price_modes.length === 0) {
          return false;
        }
        if (theme.isLargeScreen && option.isProduct === true) {
          return userInfo?.getAllowedStockTypes()?.includes(option.productType);
        }
        if (
          option.name === "homeScreen" &&
          !userInfo.showPrivateHomePage() &&
          !theme.isLargeScreen
        ) {
          return false;
        }
        return option.acceptedScreenSizes
          ? option.acceptedScreenSizes.includes(
              theme.isLargeScreen
                ? ScreenSizes.LARGE
                : theme.isTablet
                ? ScreenSizes.TABLET
                : ScreenSizes.MOBILE
            )
          : true;
      })
      .sort(
        (itemFirst: any, itemSecond: any) => itemFirst.order - itemSecond.order
      )
      .map((a) => {
        const b = { ...a };
        if (b.component === "FilterSplitScreen") {
          b.component = "ExploreNavigator";
        }

        return b;
      });
  }, [navigationData.sections, theme.isLargeScreen, theme.isTablet, userInfo]);

  return filterDataByPriceMode(sortedSections, userInfo.getPriceMode()).map(
    (tab) => ({
      ...tab,
      name: Routes[tab?.component] || Routes.HomeNavigator,
      component: componentMap[tab?.component] || componentMap.HomeNavigator,
      componentName: tab?.component,
    })
  );
};

export default useTabsData;
